<template>
  <div class="">
    <button
      v-if="data.status !== 'Used'"
      type="button"
      class="btn btn-success"
      :title="$t('text.cWaybill.markUsed')"
      @click="markUsed(data.id)"
    >
      {{ $t("text.cWaybill.markUsed") }}
    </button>

    <button
      v-else
      type="button"
      class="btn btn-secondary"
      style="cursor: not-allowed"
      :title="$t('text.cWaybill.used')"
    >
      {{ $t("text.cWaybill.used") }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
  methods: {
    markUsed: function (id) {
      // console.log("clicked used");
      this.$eventHub.$emit("_markAsUsed", id);
    },
  },
};
</script>
